
<template>
    <div class="facebook-page card-info">
        <div class="text-left">
            <h5>{{$t('configured-page')}}</h5>
        </div>
        <base-table
            :columns="columns"
            :items="pagesTable"
            :loading="!chargedRemotePages"
        >
            <template #cell(actions)="{ item }">
                <button type="button" class="btn btn-danger rounded-pill style-btn" :disabled="loading" @click="confirmAlert(item.id)">
                    {{$t('deactivate')}}
                </button>
            </template>
        </base-table>
    </div>
</template>
<script>

// Internal services js
import { RepositoryFactory } from '../../../repositories/repositoryFactory.js';
import Alert                 from '../../../helpers/Alert.js';
import { EventBus }          from '../../../helpers/EventBus.js';

// Internal components
import BaseTable from '../../../core/components/BaseTable.vue';

// External libraries
import { mapActions } from 'vuex';

const FacebookPages = RepositoryFactory.get('FacebookPages');

export default {
    components: { BaseTable },

    /**
     * Get facebook active page
     */
    mounted () {
        this.getActivePages();

        // Listen for the activate page event.
        EventBus.$off('activate-page');
        EventBus.$on('activate-page', () => {
            this.getActivePages();
            this.getConnectors();
        });
    },
    data () {
        return {
            chargedRemotePages: false,
            loading:            false,
            pagesTable:         []
        };
    },
    computed: {
        columns () {
            return [
                {
                    key:     'attributes.name',
                    label:   this.$t('page'),
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:     'attributes.admin-name',
                    label:   this.$t('activated-by'),
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:   'attributes.category',
                    label: this.$t('category')
                },
                {
                    key:     'actions',
                    label:   '',
                    thStyle: { width: '160px' },
                    tdClass: 'cell-actions'
                }
            ];
        }
    },

    methods: {
        ...mapActions('core/facebook', [
            'setActivePage',
            'setHasActivePage'
        ]),

        /**
         * Methods to get connectors linked to the account
         *
         * getConnectors get connectors linked to account
         */
        ...mapActions('core/connectors', {
            getConnectors: 'index'
        }),

        /**
         * Get active pages
         *
         * @return    void
         */
        getActivePages () {
            this.chargedRemotePages = false;
            FacebookPages.index()
                .then(request => this.showActivePage(request));
        },

        /**
         * Show active page
         *
         * @param    {object}   request   The api request
         *
         */
        showActivePage (request) {
            if (request.data.data.length > 0) {
                this.pagesTable.push(request.data.data[0]);
            }
            this.chargedRemotePages = true;
        },

        /**
         * Show confirm dialog alert
         *
         * @param    {string}   pageId    The page id
         *
         */
        confirmAlert (pageId) {
            this.$dialog.confirm({
                title:       this.$t('confirmation-required'),
                text:        this.$t('disable-page-confirm-message'),
                centerText:  true,
                confirmText: this.$t('deactivate-page'),
                danger:      true,
                onConfirm:   () => FacebookPages.delete(pageId)
            })
                .then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }

                    this.setActivePage({ activePage: null });
                    this.setHasActivePage({ hasActivePage: false });
                    this.pagesTable = [];
                    this.getActivePages();

                    EventBus.$emit('deactivate-page');
                })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                });
        }
    }
};
</script>
